/**
 * Calculates word count by first checking if the passed in object has a `word_count` property,
 * which was calculated previously by TinyMCE. If it does it returns that property, otherwise
 * it fallbacks to a more naive word count implementation.
 */
const getWordCount = (textContainerObject, textField = 'prompt_response') => {
    if (textContainerObject && textContainerObject.word_count) {
        return textContainerObject.word_count;
    }

    if (textContainerObject) {
        const text = textContainerObject[textField] || '';

        const content = text
            .replace(/<[^>]*>/g, ' ')
            .replace(/[\r\n\s]+/g, ' ')
            .replace(/&nbsp;/g, ' ')
            .trim()
            .split(' ')
            .filter((x) => x !== '');

        return content ? content.length : 0;
    }

    return 0;
};

export default {
    getWordCount
};


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/wordCount/wordCount.js